import type { FaireProductEntity } from "../../entity_types/product";

export const p_6hv7h3a5sd: FaireProductEntity = {
  token: "p_6hv7h3a5sd",
  type: "product",
  name: "Olive Enamel Keychain & Bag Charm",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/42d4f566826770e7567476622c8087614d053a946ceb4d46436b2a727810d486.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9252935b400aa3604dd050f57871fe4ce2c65cd62603594fae2e11db70ac6e42.jpeg",
    "https://cdn.faire.com/fastly/65281190f67c75305437138b72b231bdb691a06a228461cd3b2d464fd72c43a3.jpeg",
    "https://cdn.faire.com/fastly/ce2046697c32d84d64ef6dfbdeb1a2b162d0da14aaff61f4635596788ed8e2e6.jpeg",
    "https://cdn.faire.com/fastly/350cd9e89947540ca19c000c5a61975579817ddebfb47d5bc9c72c6aa44261cc.jpeg"
  ],
  priceDollars: 8,
  description: "Carry a little Mediterranean charm wherever you go with our Olive Keychain. Perfect for foodies and design lovers who love collecting playful, colorful accessories.\n\nMakes a fun gift or a personal treat for yourself!\n\n𝐆𝐨𝐨𝐝 𝐭𝐨 𝐤𝐧𝐨𝐰:\n\n• Soft enamel keychain/bag charm\n• Keyring with lobster clasp\n• Measures approximately 2” (backing card is roughly 3\"x2\")\n• Designed in Portland, Maine by Mel Andrel",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:03.661Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
